module.exports = __webpack_public_path__ + "img/slash-octagon.75f1d490.svg";